import DashboardStats from "@src/views/brands/dashboard/DashboardStats";
import CumulativeRatings from "@src/views/brands/dashboard/CumulativeRatings";
import RecommendedRDs from "@src/views/brands/dashboard/RecommendedRDs";
import RecommendedOpportunities from "@src/views/brands/dashboard/RecommendedOpportunities";

import MyPartnerships from "@src/views/brands/dashboard/MyPartnerships";

import "@styles/react/libs/charts/apex-charts.scss";
import "@styles/react/libs/charts/recharts.scss";
import "@styles/react/libs/flatpickr/flatpickr.scss";
import "@styles/react/libs/swiper/swiper.scss";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Spinner,
} from "reactstrap";
import SwiperCore, {
  Autoplay,
  EffectCoverflow,
  EffectCube,
  EffectFade,
  Lazy,
  Navigation,
  Pagination,
  Virtual,
} from "swiper";
import { useDispatch, useSelector } from "react-redux";
import {
  sendVerifyEmailLinkAction,
  sendVerifyEmailLinkResetAction,
} from "@src/views/apps/opportunitiesBrands/store/actions";
import {
  verifyEmailAction,
  verifyEmailResetAction,
} from "@src/views/pages/emailVerification/store/actions";
import { getBrandsSubscriptionPlans } from "@src/redux/actions/brandProfile/index";
import { AlertCircle, CheckCircle, Award, X } from "react-feather";
import UpgradeAnnualModal from "./UpgradeAnnualModal";
import SubscriptionExpiryBanner from "../components/SubscriptionExpiryBanner";
import RequestInvoiceModal from "../../outerPages/SubscriptionPlans/RequestInvoiceModal";
import { Formik } from "formik";
import * as yup from "yup";

SwiperCore.use([
  Navigation,
  Pagination,
  EffectFade,
  EffectCube,
  EffectCoverflow,
  Autoplay,
  Lazy,
  Virtual,
]);

const BrandDashboard = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [openModal, setOpenModal] = useState(false);
  const [upgradeModalOpen, setUpgradeModalOpen] = useState(false);
  const [invoiceModalOpen, setInvoiceModalOpen] = useState(false);
  const [upgradeBannerDismissed, setUpgradeBannerDismissed] = useState(false);

  const data = JSON.parse(localStorage.getItem(process.env.REACT_APP_USERDATA));

  const { currentPlanData } = useSelector((store) => store.brandDashboard);

  const { verifyEmailLoading, verifyEmailData, verifyEmailError } = useSelector(
    (store) => store.verifyEmailReducer
  );

  const {
    emailVerificationLoading,
    emailVerificationData,
    emailVerificationError,
  } = useSelector((store) => store.emailVerificationReducer);

  useEffect(() => {
    const rawUser = localStorage.getItem('userData') || localStorage.getItem(process.env.REACT_APP_USERDATA)
    if (rawUser) {
      try {
        const u = JSON.parse(rawUser)
        if (u?.subscription_exp || u?.subscriptionexp) {
          history.push("/subscription-plans")
          return
        }
      } catch (e) {}
    }
    dispatch(getBrandsSubscriptionPlans())
  }, [])

  useEffect(() => {
    if (currentPlanData && (currentPlanData.status === false || currentPlanData.subscription_exp)) {
      try {
        const rawUser = localStorage.getItem('userData') || localStorage.getItem(process.env.REACT_APP_USERDATA)
        if (rawUser) {
          const userData = JSON.parse(rawUser)
          userData.subscription_exp = true
          userData.subscriptionexp = true
          userData.active_subscription_id = null
          localStorage.setItem('userData', JSON.stringify(userData))
          if (process.env.REACT_APP_USERDATA) {
            localStorage.setItem(process.env.REACT_APP_USERDATA, JSON.stringify(userData))
          }
        }
      } catch (e) {}
      history.push("/subscription-plans")
    }
  }, [currentPlanData])

  const handleSendEmail = () => {
    setOpenModal(true);
    dispatch(sendVerifyEmailLinkAction());
  };

  const handleCloseModal = () => {
    dispatch(sendVerifyEmailLinkResetAction());
    dispatch(verifyEmailResetAction());
    setOpenModal(false);
  };

  useEffect(() => {
    if (emailVerificationData?.status) {
      const data = JSON.parse(
        localStorage.getItem(process.env.REACT_APP_USERDATA)
      );
      data.email_verified = true;
      localStorage.setItem(
        process.env.REACT_APP_USERDATA,
        JSON.stringify(data)
      );
    }
  }, [emailVerificationData]);

  return (
    <div id="dashboard-brands">
      {data && data.email_verified === false && (
        <div>
          <Alert color="danger">
            <div className="alert-body">
              <button className="btn p-0 text-danger" onClick={handleSendEmail}>
                <span>Your email is not verified. </span>
                <span className="cursor-pointer">
                  <u>Click to verify your email.</u>
                </span>
              </button>
            </div>
          </Alert>
        </div>
      )}

      {/* ─── Subscription Expiry Banner (Milestones: 45, 30, 15, 5 days) ─── */}
      <SubscriptionExpiryBanner
        planData={currentPlanData}
        mode="dashboard"
        onUpgradeClick={() => setUpgradeModalOpen(true)}
        onRequestInvoice={() => setInvoiceModalOpen(true)}
      />

      {/* ─── 30-60 Day Quarterly to Annual Upgrade Prompt (when not in approaching expiry window) ─── */}
      {currentPlanData?.data?.upgrade_eligible && !upgradeBannerDismissed && (!currentPlanData?.data?.is_expiry_approaching) && (
        <Card className="border-primary bg-light-primary shadow-sm mb-2">
          <CardBody className="d-flex align-items-center justify-content-between flex-wrap py-1">
            <div className="d-flex align-items-center mb-50 mb-sm-0">
              <div
                className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center mr-1"
                style={{ width: "42px", height: "42px", flexShrink: 0 }}
              >
                <Award size={22} />
              </div>
              <div>
                <h5 className="font-weight-bolder text-primary mb-25">
                  {Number(currentPlanData.data.upgrade_discount_percent) > 0
                    ? `Exclusive Offer: Save ${currentPlanData.data.upgrade_discount_percent}% by Upgrading to Annual!`
                    : "Switch to Annual Membership: Keep All Remaining Days + Get 1 Full Year!"}
                </h5>
                <span className="text-dark font-small-3">
                  Your quarterly subscription renews in{" "}
                  <strong>{currentPlanData.data.days_until_renewal} days</strong>.{" "}
                  {Number(currentPlanData.data.upgrade_discount_percent) > 0
                    ? "Upgrade today to lock in an annual discount. Your unused quarterly days will be credited automatically."
                    : "Upgrade today to annual billing. All unused quarterly time is preserved and one full calendar year is added."}
                </span>
              </div>
            </div>
            <div className="d-flex align-items-center mt-50 mt-sm-0">
              <Button
                color="primary"
                size="sm"
                className="mr-1"
                onClick={() => setUpgradeModalOpen(true)}
              >
                {Number(currentPlanData.data.upgrade_discount_percent) > 0
                  ? "Upgrade & Save"
                  : "Upgrade to Annual"}
              </Button>
              <Button
                color="flat-secondary"
                size="sm"
                className="btn-icon p-50"
                onClick={() => setUpgradeBannerDismissed(true)}
                title="Dismiss"
              >
                <X size={16} />
              </Button>
            </div>
          </CardBody>
        </Card>
      )}
      {/* <Row className="match-height mb-2">
        <Col xl="12" md="12" xs="12">
          <DashboardStats />
        </Col>
      </Row> */}
      <Row className="match-height mb-2">
        <Col xs="12">
          {/* <AdminRdSlides /> */}
          <RecommendedRDs />
        </Col>
      </Row>
      <Row className="match-height mb-2">
        <Col xs="12">
          <CumulativeRatings />
        </Col>
      </Row>
      <Row className="match-height mb-2">
        <Col lg="12" sm="12">
          <RecommendedOpportunities />
        </Col>
      </Row>
      <Row className="match-height mb-2">
        <Col xs="12">
          <MyPartnerships />
        </Col>
      </Row>
      <Modal isOpen={openModal} className="modal-dialog-centered">
        <ModalHeader>Verify Email</ModalHeader>
        <ModalBody style={{ minHeight: "50px" }}>
          {verifyEmailLoading ? (
            <div className="text-center">
              <Spinner color="primary" />
            </div>
          ) : verifyEmailData?.status ? (
            <div className="text-break">
              <p>
                <CheckCircle size={14} style={{ color: "#56B6FF" }} /> Email
                verification code has been sent to your email address.
              </p>
              <p>
                <CheckCircle size={14} style={{ color: "#56B6FF" }} /> Copy and
                paste the code below to verify your email.
              </p>
              {emailVerificationData?.status === true && (
                <Alert color="success">
                  <div className="alert-body">
                    <span>{emailVerificationData?.msg}</span>
                  </div>
                </Alert>
              )}
              {emailVerificationData?.status === false && (
                <Alert color="danger">
                  <div className="alert-body">
                    <span>{emailVerificationData?.msg}</span>
                  </div>
                </Alert>
              )}
              <Formik
                initialValues={{
                  code: "",
                }}
                validationSchema={yup.object().shape({
                  code: yup
                    .number()
                    .required("This field is required.")
                    .typeError("Should be a number"),
                })}
                onSubmit={(values) => {
                  dispatch(verifyEmailAction({ token: values.code }));
                }}
              >
                {({
                  errors,
                  handleBlur,
                  handleChange,
                  handleSubmit,
                  touched,
                  values,
                  setFieldValue,
                }) => (
                  <Form onSubmit={handleSubmit}>
                    <FormGroup>
                      <Input
                        type="number"
                        name="code"
                        id="code"
                        placeholder="Paste code here..."
                        value={values.code}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        disabled={
                          emailVerificationLoading ||
                          emailVerificationData?.status
                        }
                      />
                      <div className="validation-err">
                        {touched.code && errors.code}
                      </div>
                    </FormGroup>
                    <div className="text-right">
                      <Button
                        color="danger"
                        onClick={handleCloseModal}
                        className="mr-1"
                        disabled={emailVerificationLoading}
                      >
                        Close
                      </Button>
                      <Button
                        color="primary"
                        type="submit"
                        disabled={
                          emailVerificationLoading ||
                          emailVerificationData?.status
                        }
                      >
                        {emailVerificationLoading ? (
                          <Spinner style={{ width: "16px", height: "16px" }} />
                        ) : (
                          "Verify"
                        )}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          ) : (
            <div>
              <p className="text-center">
                <AlertCircle size={50} />
              </p>
              <p>{verifyEmailData?.msg}</p>
            </div>
          )}
        </ModalBody>
      </Modal>

      {/* ─── Annual Upgrade Modal ─── */}
      <UpgradeAnnualModal
        isOpen={upgradeModalOpen}
        toggle={() => setUpgradeModalOpen(!upgradeModalOpen)}
        currentPlanData={currentPlanData}
        onUpgradeSuccess={() => dispatch(getBrandsSubscriptionPlans())}
      />

      {/* ─── Pay by Invoice Modal ─── */}
      <RequestInvoiceModal
        isOpen={invoiceModalOpen}
        toggle={() => {
          setInvoiceModalOpen(!invoiceModalOpen);
          dispatch(getBrandsSubscriptionPlans());
        }}
        user={data}
        currentPlanData={currentPlanData}
      />
    </div>
  );
};

export default BrandDashboard;
